export default function followTrekFactory(ajax) {
  return async function followTrek(Id) {
    return ajax({ resource: `trips/treks/${Id}/follow`, method: 'put' });
  };
}



// WEBPACK FOOTER //
// ./src/services/followTrek.js